module.exports = __webpack_public_path__ + "img/banner_recomanda.dc6fb35e.png";